import { render, staticRenderFns } from "./JsonEditor.vue?vue&type=template&id=53e6c2c8"
import script from "./JsonEditor.vue?vue&type=script&lang=js"
export * from "./JsonEditor.vue?vue&type=script&lang=js"
import style0 from "./JsonEditor.vue?vue&type=style&index=0&id=53e6c2c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports